function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
}), React.createElement("path", {
  d: "M7.99996 0C4.56025 0 1.6279 2.171 0.497559 5.21741H15.5024C14.372 2.171 11.4397 0 7.99996 0Z",
  fill: "#D80027"
}), React.createElement("path", {
  d: "M7.99996 16C11.4397 16 14.372 13.829 15.5024 10.7826H0.497559C1.6279 13.829 4.56025 16 7.99996 16Z",
  fill: "black"
}), React.createElement("path", {
  d: "M10.7825 7.13047H8.69556C8.69556 6.74628 8.38409 6.43481 7.9999 6.43481C7.61572 6.43481 7.30425 6.74628 7.30425 7.13047H5.21729C5.21729 7.51469 5.55194 7.82613 5.93613 7.82613H5.91294C5.91294 8.21035 6.22438 8.52178 6.60859 8.52178C6.60859 8.906 6.92003 9.21744 7.30425 9.21744H8.69556C9.07978 9.21744 9.39121 8.906 9.39121 8.52178C9.77543 8.52178 10.0869 8.21035 10.0869 7.82613H10.0637C10.4479 7.82613 10.7825 7.51469 10.7825 7.13047Z",
  fill: "#FF9811"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));
const SvgEgypt = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgEgypt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/egypt.1e183885.svg";
export { ForwardRef as ReactComponent };